export class Preset {
  constructor(private readonly id: string, private readonly label: string, private category: string = '') {}

  getId() {
    return this.id;
  }

  getLabel() {
    return this.label;
  }

  getCategory() {
    return this.category;
  }

  toFilterFormat(includeCategory: boolean = false) {
    const category = this.getCategory();
    const suffix = category && includeCategory ? ` (${category})` : '';
    return {
      value: this.id,
      label: `${this.getLabel()}${suffix}`,
    };
  }
}
